<template>
    <iframe :src="src" :width="width" :height="height" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
</template>

<script>
	export default {
		name: "VideoPlayer",
		props: {
			src: {
				type: String,
			},
			width: {
				type: String,
				default: "640"
			},
			height: {
				type: String,
				default: "320"
			}
		},
	}
</script>

<style scoped>
	iframe {
		min-height: 360px;
		border-radius: 15px;
		box-shadow: 3px 3px 6px #ddd;
	}
</style>